/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_contact_signin_body = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You need an account to submit a tool idea or bug report. It only takes a moment.`)
};

const es_contact_signin_body = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Necesitas una cuenta para enviar una idea de herramienta o un informe de error. Solo toma un momento.`)
};

const de_contact_signin_body = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du benötigst ein Konto, um eine Tool-Idee oder einen Fehlerbericht einzureichen. Es dauert nur einen Moment.`)
};

const nl_contact_signin_body = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je hebt een account nodig om een tool-idee of bugmelding in te dienen. Het kost maar een moment.`)
};

const fr_contact_signin_body = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez besoin d'un compte pour proposer une idée d'outil ou signaler un bug. Cela ne prend qu'un instant.`)
};

const it_contact_signin_body = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ti serve un account per inviare un'idea per uno strumento o segnalare un bug. Richiede solo un momento.`)
};

const pt_br2_contact_signin_body = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você precisa de uma conta para enviar uma ideia de ferramenta ou um relato de bug. Leva só um instante.`)
};

const pt_contact_signin_body = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precisas de uma conta para enviar uma ideia de ferramenta ou um relatório de erro. Demora apenas um momento.`)
};

const ja_contact_signin_body = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ツールのアイデアやバグ報告を送るにはアカウントが必要です。すぐに作成できます。`)
};

const zh_contact_signin_body = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交工具创意或 bug 反馈需要账户。只需片刻即可完成。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const contact_signin_body = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_signin_body(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("contact_signin_body", locale)
	if (locale === "en") return en_contact_signin_body(inputs)
	if (locale === "es") return es_contact_signin_body(inputs)
	if (locale === "de") return de_contact_signin_body(inputs)
	if (locale === "nl") return nl_contact_signin_body(inputs)
	if (locale === "fr") return fr_contact_signin_body(inputs)
	if (locale === "it") return it_contact_signin_body(inputs)
	if (locale === "pt-BR") return pt_br2_contact_signin_body(inputs)
	if (locale === "pt") return pt_contact_signin_body(inputs)
	if (locale === "ja") return ja_contact_signin_body(inputs)
	return zh_contact_signin_body(inputs)
};